import types from '../actions/_actionTypes';
import initialState from './initialState';

const scan = (state = initialState.scans, action) => {
  var newState;

  switch (action.type) {
    case types.RECEIVE_SCAN:
      newState = Object.assign({}, state);
      newState.scanData = Object.assign({}, state.scanData);
      newState.scanData[action.name.toLowerCase()] = action.data.data;
      return newState;
    case types.RECEIVE_USER_SCANS:
      return Object.assign({}, state, {
        isLoading: false,
        userScans: action.data.data.scans,
        staticScans: action.data.data.staticScans || []
      });
    case types.RECEIVE_LAST_SCAN:
      return Object.assign({}, state, {
        lastScan: action.data.data.scan
      });
    case types.SAVE_SCAN: {
      const newScans = Object.assign([], state.userScans);
      newScans.push(action.data.data.scan);
      return Object.assign({}, state, {
        userScans: newScans
      });
    }
    case types.DELETE_SCAN:
      return Object.assign({}, state, {
        userScans: state.userScans.filter((scan) => scan.id !== action.id)
      });
    case types.ERROR_REQUESTING_SCAN:
      newState = Object.assign({}, state);
      return newState;
    case types.ERROR_REQUESTING_USER_SCANS:
      newState = Object.assign({}, state);
      return newState;
    case types.ERROR_REQUESTING_LAST_SCAN:
      newState = Object.assign({}, state);
      return newState;
    case types.ERROR_DELETING_SCAN:
      newState = Object.assign({}, state);
      return newState;
    case types.SET_SELECTED_SCAN:
      return Object.assign({}, state, {
        selectedScan: action.data
      });
    case types.SET_ENABLED_SCAN_CRITERIA: {
      const fieldId = action.fieldId;
      const enabled = action.enabled;

      const nextMap = Object.assign({}, state.enabledScanCriteria);
      if (enabled === false) {
        nextMap[fieldId] = false;
      } else {
        delete nextMap[fieldId];
      }

      return Object.assign({}, state, {
        enabledScanCriteria: nextMap
      });
    }
    case types.RESET_ENABLED_SCAN_CRITERIA:
      return Object.assign({}, state, {
        enabledScanCriteria: {}
      });
    default:
      return state;
  }
};

export default scan;
